/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ZohoServiceDeskAlertDescriptionAttribute {
    location = 'location',
    metric_name = 'metric_name',
    metric_value = 'metric_value',
    name = 'name',
    operator = 'operator',
    project_name = 'project_name',
    resource_group = 'resource_group',
    resource_name = 'resource_name',
    resource_type = 'resource_type',
    service_account_name = 'service_account_name',
    service_name = 'service_name',
    threshold = 'threshold',
    time_aggregation = 'time_aggregation'
}
